import { IotnetGateway } from "../../apis/stats/rest/models";

export function hasCoordinates(gateway: IotnetGateway): boolean {
  // 0/0 is in the Atlantic; the backend uses it for gateways without a location.
  return (
    Number.isFinite(gateway.latitude)
    && Number.isFinite(gateway.longitude)
    && !(gateway.latitude === 0 && gateway.longitude === 0)
  );
}
